<template>
  <ReviewsCategoriesTabs
    ref="categoriesTabRef"
    :tabs="tabItems"
    :content-type="contentType"
  >
    <template v-slot:title>
      <h3 v-if="title" class="tabs-title">
        {{ title }}
      </h3>
    </template>
    <template
      v-for="({ component, ...tab }, index) in tabContentElements"
      v-slot:[tab.name]
    >
      <component :key="index" :is="component" v-bind="tab" :groups="groups" />
    </template>
  </ReviewsCategoriesTabs>
</template>

<script>
import ReviewsCategoriesTabs from "@/components/Reviews/Categories/ReviewsCategoriesTabs.vue";

export default {
  name: "ReviewsCategoriesTabsContainer",
  components: {
    ReviewsCategoriesTabs
  },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    groups: {
      type: Array
    },
    title: {
      type: String
    },
    contentType: {
      type: String,
      default: "table"
    }
  },
  computed: {
    tabItems() {
      return this.tabs.map(({ name, text, id }) => ({ name, text, id }));
    },
    tabContentElements() {
      return this.tabs.map(
        ({ name, component, searchParamName, fetchMethod, fieldName }) => ({
          name,
          component,
          searchParamName,
          fetchMethod,
          fieldName
        })
      );
    }
  }
};
</script>
<style lang="scss">
.tabs-title {
  margin-top: $spacing * 10;
  font-weight: 700;
}
</style>
